// extracted by mini-css-extract-plugin
export default {"mobile_side":"Store_mobile_side__lpL9i","final_gridd":"Store_final_gridd__0FM2R"};